module.exports = new __parcel__URL__("cornershop-shopper-welcome.4225ec78.png").toString();